class ApplyDiscountAvailabilityProvider {
    constructor(private readonly canApplyDiscount: boolean) {}

    isDiscountApplyAvailable(): boolean {
        return this.canApplyDiscount;
    }
}

export default ApplyDiscountAvailabilityProvider;
